<template>
<div 
  @click="onClick"  
  style="border:1px solid #ddd;border-radius:10px;padding:5px 10px;background: #fff;"
>
  <v-layout row wrap>
    <v-flex xs10 style="text-align:left;">
      <p class="formElementLabel"><v-icon small>restaurant</v-icon> {{label_text}}
        <img style="height:15px" src="/img/powered_by_google_on_white.png">
      </p>
      <p style="font-weight: bold;" class="primary--text">{{name}}</p>
      <p style="">{{address}}</p>
    </v-flex>
    <v-flex xs2 style="text-align:center;padding-top:10px;">
      <v-btn icon small class="primary--text"><v-icon>launch</v-icon></v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  name: 'ShopGoogleCardMin',
  data () {
    return {
      label_text: '飲食店　'
    }
  },
  computed: {
    address () {
      return this.shop.formatted_address
    },
    name () {
      return this.shop.name
    }
  },
  props: {
    shop: Object
  },
  mounted () {
  },
  methods: {
    onClick () {
      this.$emit('onClick')
    }
  },
  components: {
  }
}
</script>

<style scoped>
p {
  padding: 0;
  margin-bottom: 2px;
}
.formElementLabel {
  text-align: left;
  color:#888;
}
</style>